import {Product} from "@/entities/Product";
import {isDefined} from "@/utils";
import {Theme} from '@/entities/Theme';

export class ProductContainer {

  private _productsMap: Record<string, Product[]> = {};
  private _filteredProducts: Product[] = [];
  private readonly _products: Product[] = [];
  private readonly _themes: Theme[] = []
  private readonly _sortRegex = new RegExp('[A-Z]');

  constructor(entities: Product[], themes: Theme[]) {
    this.createProductsMap(entities);
    this._products = entities;
    this._themes = themes;
  }

  private createProductsMap(entities: Product[]): void {
    this._productsMap = {}
    this._filteredProducts = entities;
    for (const product of entities) {
      let firstChar = product.sortOrder[0].toUpperCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
      if (!this._sortRegex.test(firstChar)) {
        firstChar = '#';
      }
      if (!isDefined(this._productsMap[firstChar])) {
        this._productsMap[firstChar] = [];
      }
      this._productsMap[firstChar].push(product);
    }
  }

  public getProductsMap(pageSize: number): Record<string, Product[]> {
    const copy = {};
    if (pageSize <= 0) {
      return {};
    }
    for (let [key, value] of Object.entries(this._productsMap)) {
      if (value.length > pageSize) {
        copy[key] = value.slice(0, pageSize);
        break;
      } else {
        copy[key] = value;
        pageSize = pageSize - value.length;
        if (pageSize <= 0) {
          break;
        }
      }
    }
    return copy;
  }


  get products(): Product[] {
    return this._products;
  }


  get themes(): Theme[] {
    return this._themes;
  }

  public hasMorePages(pageSize): boolean {
    return this._filteredProducts.length > pageSize;
  }

  public filterProducts(searchValue: string, filters: Record<string, string>): void {
    let filteredProducts: Product[];
    searchValue = searchValue.trim().toLowerCase();
    if (searchValue.length > 0) {
      filteredProducts = this.applyFilters(filters, this._products);
      filteredProducts = filteredProducts.filter(e => {
        return e.hasSearchValue(searchValue);
      });
      filteredProducts = this.applyFilters(filters, filteredProducts);
    } else {
      filteredProducts = this.applyFilters(filters, this._products);
    }
    this.createProductsMap(filteredProducts);
  }

  private applyFilters(filters: Record<string, string>, products: Product[]): Product[] {
    if (isDefined(filters) && Object.entries(filters).length > 0) {
      for (const [key, value] of Object.entries(filters)) {
        products = products.filter(e => {
          if (isDefined(e.themes)) {
            return e.themes.indexOf(value) > -1;
          }
          return false;
        });
      }
    }
    return products;
  }

  public hasEntries(): boolean {
    return JSON.stringify(this._productsMap) !== JSON.stringify({});
  }

}
